import { render, staticRenderFns } from "./ProdutosForm.vue?vue&type=template&id=c644ac82"
import script from "./ProdutosForm.vue?vue&type=script&lang=js"
export * from "./ProdutosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports